import React, { useMemo } from "react";
import SearchableSelect from "./SearchableSelect";
import { useLocalization } from "../../providers/LocalizationProvider";

export default function UserSelect({
    label,
    users = [],
    value,
    defaultValue,
    onChange,
    name,
    includeDeleted = false,
    required = true
}) {
    const { t } = useLocalization();
    const filtered = useMemo(() => {
        return users.filter(u => (includeDeleted || !u.deletedAt));
    }, [users, includeDeleted]);

    const getUserDisplayName = (user) => {
        const firstName = user.firstName || '';
        const lastName = user.lastName || user.name || '';
        return [firstName, lastName].filter(Boolean).join(' ') || t('common.notAssigned');
    };

    return (
        <SearchableSelect
            label={label}
            name={name}
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
            placeholder={t('common.searchUser')}
            options={filtered}
            getOptionValue={(option) => option.id}
            getOptionLabel={getUserDisplayName}
            getOptionSearchText={(option) => {
                const firstName = option.firstName || '';
                const lastName = option.lastName || option.name || '';
                const email = option.email || '';
                return [firstName, lastName, email].filter(Boolean).join(' ').toLowerCase();
            }}
            required={required}
            loading={users.length === 0}
            emptyMessage={t('common.noUsersFound')}
        />
    );
} 